export default {
  'auth.loginHero': 'Hành trình Việt Nam của bạn bắt đầu từ đây',
  'auth.loginHeroText': 'Đăng nhập để quản lý đặt tour, lưu các tour yêu thích và tiếp tục lên kế hoạch cho chuyến đi của đời bạn.',
  'auth.welcomeBack': 'Chào mừng trở lại',
  'auth.signInContinue': 'Đăng nhập để tiếp tục hành trình của bạn.',
  'auth.resetPrompt': 'Nhập email để đặt lại mật khẩu của bạn.',
  'auth.emailAddress': 'Địa chỉ email',
  'auth.password': 'Mật khẩu',
  'auth.forgotPassword': 'Quên mật khẩu?',
  'auth.rememberMe': 'Ghi nhớ tôi',
  'auth.signingIn': 'Đang đăng nhập...',
  'auth.signIn': 'Đăng nhập',
  'auth.sending': 'Đang gửi...',
  'auth.sendResetLink': 'Gửi liên kết đặt lại',
  'auth.backToSignIn': 'Quay lại đăng nhập',
  'auth.noAccount': 'Chưa có tài khoản?',
  'auth.signUp': 'Đăng ký',
  'auth.hidePassword': 'Ẩn mật khẩu',
  'auth.showPassword': 'Hiện mật khẩu',
  'auth.resetLinkSent': 'Chúng tôi đã gửi liên kết đặt lại mật khẩu đến email của bạn. Vui lòng kiểm tra hộp thư.',
  'auth.somethingWentWrong': 'Đã xảy ra lỗi. Vui lòng thử lại.',
  'auth.sendOtp': 'Gửi mã OTP',
  'auth.sendingOtp': 'Đang gửi mã...',
  'auth.otpSent': 'Chúng tôi đã gửi mã xác minh 6 số đến email của bạn. Vui lòng kiểm tra hộp thư.',
  'auth.otpSentShort': 'Nhập mã xác minh 6 số được gửi đến email của bạn.',
  'auth.otpCode': 'Mã xác minh',
  'auth.verifyOtp': 'Xác minh & đăng nhập',
  'auth.verifySignUp': 'Xác minh & tạo tài khoản',
  'auth.verifying': 'Đang xác minh...',
  'auth.resendOtp': 'Gửi lại mã',
  'auth.resendIn': 'Gửi lại sau {s}s',
  'auth.changeEmail': 'Đổi email',
  'auth.otpInvalid': 'Vui lòng nhập mã hợp lệ gồm 6 số.',
  'auth.registerHero': 'Những hành trình khó quên đang chờ đón',
  'auth.registerHeroText': 'Tạo tài khoản để đặt tour, nhận gợi ý cá nhân hóa và lưu giữ mọi kỷ niệm ở một nơi.',
  'auth.createAccount': 'Tạo tài khoản của bạn',
  'auth.joinUs': 'Tham gia cùng chúng tôi và bắt đầu lên kế hoạch cho chuyến đi Việt Nam hoàn hảo.',
  'auth.fullName': 'Họ và tên',
  'auth.yourFullName': 'Họ tên đầy đủ của bạn',
  'auth.phoneNumber': 'Số điện thoại',
  'auth.atLeast6': 'Tối thiểu 6 ký tự',
  'auth.confirmPassword': 'Xác nhận mật khẩu',
  'auth.reenterPassword': 'Nhập lại mật khẩu',
  'auth.creatingAccount': 'Đang tạo tài khoản...',
  'auth.terms': 'Khi đăng ký, bạn đồng ý với Điều khoản dịch vụ và Chính sách quyền riêng tư của chúng tôi.',
  'auth.haveAccount': 'Đã có tài khoản?',
  'auth.passwordMin6': 'Mật khẩu phải có ít nhất 6 ký tự.',
  'auth.passwordMismatch': 'Mật khẩu không khớp.',
  'auth.accountCreated': 'Đã tạo tài khoản! Vui lòng kiểm tra email để xác nhận đăng ký.',
  'auth.resetHero': 'Khởi đầu mới cho hành trình của bạn',
  'auth.resetHeroText': 'Đặt mật khẩu mới và nhanh chóng trở lại việc lên kế hoạch cho chuyến phiêu lưu Việt Nam hoàn hảo.',
  'auth.resetTitle': 'Đặt lại mật khẩu',
  'auth.checking': 'Đang kiểm tra liên kết đặt lại...',
  'auth.chooseNew': 'Chọn mật khẩu mới cho tài khoản của bạn.',
  'auth.invalidLink': 'Liên kết đặt lại này không hợp lệ hoặc đã hết hạn.',
  'auth.cantVerify': 'Chúng tôi không thể xác minh liên kết đặt lại của bạn. Nó có thể đã hết hạn hoặc đã được sử dụng. Vui lòng yêu cầu một liên kết mới.',
  'auth.continueSignIn': 'Tiếp tục đăng nhập',
  'auth.newPassword': 'Mật khẩu mới',
  'auth.confirmNewPassword': 'Xác nhận mật khẩu mới',
  'auth.reenterNewPassword': 'Nhập lại mật khẩu mới',
  'auth.updating': 'Đang cập nhật...',
  'auth.updatePassword': 'Cập nhật mật khẩu',
  'auth.passwordUpdated': 'Mật khẩu của bạn đã được cập nhật thành công.',
  'profile.loading': 'Đang tải tài khoản của bạn...',
  'profile.signInToView': 'Đăng nhập để xem tài khoản',
  'profile.manageText': 'Quản lý đặt tour, tour đã lưu và hồ sơ của bạn ở cùng một nơi.',
  'profile.myAccount': 'Tài khoản của tôi',
  'profile.welcomeBack': 'Chào mừng trở lại! Quản lý đặt tour và kế hoạch du lịch của bạn tại đây.',
  'auth.emailPlaceholder': 'ban@example.com',
  'auth.loginAlt': 'Vịnh Hạ Long Việt Nam lúc hoàng hôn',
  'auth.loginTitle': 'Du lịch Vịnh Hạ Long Việt Nam',
  'auth.registerAlt': 'Phố cổ Hội An Việt Nam lúc chạng vạng',
  'auth.registerTitle': 'Du lịch Hội An Việt Nam',
};